// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import hopt from 'hola_opt';
// @ts-ignore
import cookie from 'cookie';

export const use_campaign = ()=>{
    const {browser = [], vpn = []} = hopt.www_hola.campaigns||{};
    const c_browser = cookie.get('c_browser');
    const c_vpn = cookie.get('c_vpn');
    return browser.find(({name})=>name==c_browser) ||
        vpn.find(({name})=>name==c_vpn);
};
